import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";

interface SuccessAlertProps {
  email: string;
  onResend: () => void;
}

export default function SuccessAlert({ email, onResend }: SuccessAlertProps) {
  return (
    <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
      Link-ul de acces a fost trimis la {email}. Verifică-ți email-ul și click
      pe link pentru a te autentifica.
      <br />
      <Button
        size="small"
        onClick={onResend}
        sx={{ mt: 1, color: "success.main" }}
      >
        Trimite din nou
      </Button>
    </Alert>
  );
}
